import * as yup from "yup";
import { Schema } from "../../schema";
import { SingleValueObject } from "../base-value-object";
export class Version extends SingleValueObject {
    version;
    constructor(args) {
        super(args);
        this.version = args.version;
    }
    validator(args) {
        return this.validate(args, Version.schema);
    }
    equals(t) {
        return this.version === t?.version;
    }
    getValue() {
        return this.version;
    }
    toString() {
        return this.version.toString();
    }
    increment() {
        return new Version({
            version: this.version + 1,
        });
    }
    static hasVersion(v) {
        return !!v.version;
    }
    static initial() {
        return new Version({ version: 1 });
    }
    static schema(required = true) {
        return Schema.required({
            version: yup.number().min(1).label("バージョン"),
        }, required);
    }
}
//# sourceMappingURL=version.js.map